import { useSelector } from 'react-redux';
import { path } from 'ramda';

import createShowActionStoreModule from './show';
import createLoadActionStoreModule from './load';

export const createSelector = (slicePath, field) => () =>
  useSelector((state) => path([...slicePath, field], state));

export default { createShowActionStoreModule, createLoadActionStoreModule };
